import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { X } from "lucide-react";
import { NEW_APP_URL } from "@/config/retired";

interface SubscriptionOverlayProps {
  onClose: () => void;
}

// Retired build: plans and payments are handled only in the new app.
export function SubscriptionOverlay({ onClose }: SubscriptionOverlayProps) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="relative">
          <Button variant="ghost" size="icon" className="absolute right-2 top-2" onClick={onClose} aria-label="Cerrar">
            <X className="h-4 w-4" />
          </Button>
          <CardTitle>Seguí en la nueva versión</CardTitle>
          <CardDescription>
            Los planes y las funciones pagas ahora están en la nueva versión de DoctIA. Tu cuenta y tu plan son los mismos.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild className="w-full">
            <a href={`${NEW_APP_URL}/planes`}>Ver planes en la nueva versión</a>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
